/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddInventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersAddInventoryStockTransferDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/add-inventory-stock-transfer-dto';
import { InventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';

export interface AddStockTransfer$Params {
  inventoryId: string;
      body?: DigiworkMaitreDPosDtoInventoryStockTransfersAddInventoryStockTransferDto
}

export function addStockTransfer(http: HttpClient, rootUrl: string, params: AddStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
  const rb = new RequestBuilder(rootUrl, addStockTransfer.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>;
    })
  );
}

addStockTransfer.PATH = '/api/inventories/{inventoryId}/transfers';
